import { ReasonCategoryEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity,UpdateDateColumn, PrimaryGeneratedColumn, VersionColumn } from "typeorm";


@Entity('reasons')
export class Reasons {

    @PrimaryGeneratedColumn("increment",{name:'reasons_id'})
    reasonId:number;

    @Column("char",{
        nullable:false,
        length:50,
        name:"reasons_code"
    })
    reasonCode:string;

    @Column("char",{
        nullable:false,
        length:50,
        name:"reasons_name"
    })
    reasonName:string;

    @Column("enum",{
        nullable:true,
        name:"category",
        enum: ReasonCategoryEnum,
        default:ReasonCategoryEnum.GENERAL
    })
    category:ReasonCategoryEnum;

    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
    })
    isActive:boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    updateAt: Date;

    @Column("varchar", {
        nullable: false,
        default:1,
        name: "created_user"
    })
    createdUser: string | null;
  
  
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar",{
        nullable : true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
  createdAt: Date;
}